var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitwarden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21698_199306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7334 1.27143C20.5547 1.08954 20.3431 1 20.1013 1H3.89862C3.65404 1 3.44519 1.08954 3.26656 1.27143C3.08794 1.45332 3 1.66879 3 1.91503V12.915C3 13.735 3.15664 14.5492 3.46992 15.3579C3.7832 16.1639 4.17343 16.8802 4.63786 17.507C5.10228 18.131 5.65464 18.7411 6.2977 19.3343C6.94075 19.9275 7.53434 20.4172 8.07571 20.809C8.61983 21.2007 9.18594 21.5701 9.77677 21.9199C10.3676 22.2697 10.7881 22.5047 11.0354 22.6278C11.2827 22.7509 11.4833 22.8489 11.6317 22.9132C11.7444 22.9692 11.8653 23 11.9972 23C12.1291 23 12.25 22.972 12.3627 22.9132C12.5139 22.8461 12.7117 22.7509 12.9618 22.6278C13.2092 22.5047 13.6296 22.2668 14.2204 21.9199C14.8113 21.5701 15.3774 21.2007 15.9215 20.809C16.4656 20.4172 17.0592 19.9247 17.7022 19.3343C18.3453 18.7411 18.8977 18.1338 19.3621 17.507C19.8265 16.8802 20.214 16.1666 20.53 15.3579C20.8433 14.552 20.9999 13.7377 20.9999 12.915V1.91783C21.0027 1.66879 20.912 1.45332 20.7334 1.27143ZM18.6449 13.0186C18.6449 17.0006 12 20.4311 12 20.4311V3.35614H18.6449C18.6449 3.35614 18.6449 9.03663 18.6449 13.0186Z",
    fill: "#175DDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21698_199306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white",
    transform: "translate(3 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitwarden);
export default __webpack_public_path__ + "static/media/Bitwarden.e2805b85f4f2d6693a81d052be42d325.svg";
export { ForwardRef as ReactComponent };